import { render, staticRenderFns } from "./consultDetail.vue?vue&type=template&id=216e360b"
import script from "./consultDetail.vue?vue&type=script&lang=js"
export * from "./consultDetail.vue?vue&type=script&lang=js"
import style0 from "./consultDetail.vue?vue&type=style&index=0&id=216e360b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports